import { render, staticRenderFns } from "./yearSwiper.vue?vue&type=template&id=09640756&scoped=true&"
import script from "./yearSwiper.vue?vue&type=script&lang=js&"
export * from "./yearSwiper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./yearSwiper.vue?vue&type=style&index=0&id=09640756&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "09640756",
  "5352a839"
  
)

export default component.exports